import React, { useState, useRef, useEffect } from 'react';
import Header from '../../components/Header';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';
import DargDrop from '../../assets/images/dargdrop.png';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { toast } from 'react-toastify';
import { DataStore, Storage } from 'aws-amplify';
import { Handbook } from '../../models';
import moment from 'moment/moment';

const NewHandBook = () => {
  let navigate = useNavigate();
  //const toast = useRef(null);
  const { user } = useAuthenticator(context => [context.user]);
  const [handbookName, setHandbookName] = useState('');
  const [description, setHandbookDescription] = useState('');

  const [localFile, setLocalFile] = useState(null);
  const [fileName, setLocalFileName] = useState(null);
  const [handbookFile, setFile] = useState(null);

  const onSelectFile = e => {
    let file = e.files[0];
    setLocalFileName(file.name);
    setFile(file);
    setLocalFile(URL.createObjectURL(file));
    //toast.current.show({ severity: "info", summary: "Success", detail: "File Uploaded" });
  };

  const uploadFileToBucket = async () => {
    const filePath = 'handbook/' + fileName;
    toast.loading('Uploading please wait...');
    try {
      const result = await DataStore.save(
        new Handbook({
          handbook_name: handbookName,
          description: description,
          file_path: fileName,
          created_by: user.attributes.name,
          created_date: moment().format('YYYY-MM-DD')
        })
      );
      await Storage.put(filePath, handbookFile, {
        resumable: true,
        completeCallback: event => {
          toast.dismiss();
        },
        errorCallback: err => {
          toast.error(err.message);
        }
      });

      clearForm();
      navigate('/employee-handbook');
    } catch (error) {
      console.log(error);
    }
  };
  const clearForm = () => {
    setHandbookName('');
    setFile('');
    setLocalFile('');
    setLocalFileName();
    setHandbookDescription('');
  };
  const onClickSendHandbook = () => {
    uploadFileToBucket();
  };

  const isEnableSaveHandbookButton = () => {
    return handbookName !== '' && description !== '' && localFile !== null;
  };
  console.log(user);
  return (
    <>
      <Header />
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="py-5 lg:flex lg:items-center lg:justify-between">
          <div className="flex-1 min-w-0">
            <h6 className="flex items-center text-2xl font-semibold leading-7 text-gray-600 sm:truncate sm:tracking-tight">
              New HandBook
            </h6>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-7">
          <div className="col-span-4">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
              <div className="mt-2 mb-1">
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">
                  HandBook Name <span className="text-[red] pl-0.2">*</span>
                </label>
                <div className="mt-2">
                  <InputText
                    value={handbookName}
                    required
                    onChange={e => {
                      setHandbookName(e.target.value);
                    }}
                    id="username"
                    placeholder="HandBook.."
                    className="w-full placeholder:text-[#667085] h-12 "
                    aria-describedby=""
                  />
                </div>
              </div>
              <div className="mt-2 mb-1">
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium pb-3" htmlFor="username">
                  HandBook Description <span className="text-[red] pl-0.2">*</span>
                </label>
                <div className="mt-2">
                  <InputText
                    required
                    value={description}
                    onChange={e => {
                      setHandbookDescription(e.target.value);
                    }}
                    id="description"
                    placeholder="HandBook Description"
                    className="w-full placeholder:text-[#667085] h-12 "
                    aria-describedby=""
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-3">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-1">
              <div className="card md:ps-6">
                {/* <Toast ref={toast}></Toast> */}
                <label className="text-[#344054] text-sm md:text-[1vw] font-medium" htmlFor="Upload ">
                  Upload Handbook <span className="text-[red] pl-0.2">*</span>
                </label>
                <div className="relative mt-3">
                  {
                    (fileName) ?
                      <div className='border-dashed border-2 flex justify-center items-center border-indigo-600 rounded-lg h-40 w-100'> 
                        <i className="pi pi-file-pdf mr-2" style={{ fontSize: '2rem' }}></i>
                        <span>{fileName}</span>
                      </div> :
                      <img className="w-100" src={localFile || DargDrop} alt={fileName || 'DropZone'} />
                  }
                  <FileUpload
                    className="absolute top-0 bottom-0 left-0 right-0 flex justify-center opacity-0"
                    mode="basic"
                    name="demo[]"
                    accept="image/"
                    maxFileSize={1000000}
                    onSelect={onSelectFile}
                    auto
                    chooseLabel="Browse"
                  />
                </div>
              </div>
              <div>
                <div className="flex justify-end gap-3 mt-3 mb-3 grow">
                  {/* <Link
                    to="/employee-handbook"
                    className=" py-2 px-5 bg-white text-[#344054] transition ease-in duration-200 text-[14px] text-center font-medium  shadow-md focus:outline-none justify-center rounded-lg border border-[#D0D5DD] rounded-md dark:bg-[#333231] dark:border-[#333231] dark:text-[#FFFFFF]"
                  >
                    Cancel
                  </Link> */}

                  <Link
                    to="/employee-handbook"
                    className="text-center custmBtn bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] text-[#344054] radius8"
                  >
                    Cancel
                  </Link>
                  <button
                    disabled={!isEnableSaveHandbookButton()}
                    onClick={onClickSendHandbook}
                    className="text-center custmBtn blue radius8 disabled:bg-zinc-400"
                  >
                    Save Handbook
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewHandBook;
